// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"694":"68bd8841","900":"f4e0e120"}[chunkId] + ".chunk.css";
};